import { formatDate } from "./formatDate";

export const downloadExcel = (name: string, excel: any) => {
    const date= new Date();
    const formattedDate = formatDate(date);

    const url = window.URL.createObjectURL(new Blob([excel]));
    const link = document.createElement('a');
    link.href = url;
    link.download = `${name}-${formattedDate}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};